export const equalLengthRule = (length: number) => ({
	name: 'equal-length',
	validate: (value: string) => value.length === length,
});
